import styled from 'styled-components'

export const PageWrapper = styled.div`
  max-width: 1024px;
  width: 100%;
`

export const CreateWrapper = styled.div`
  width: 100%;
`

export const Title = styled.div`
  width: 100%;
  font-weight: bold;
  font-size: 2rem;
  margin-bottom: 1rem;
`

export const Content = styled.div`
  width: 100%;
  display: flex;
  margin-bottom: 1rem;

  form {
    width: 100%;

    .file {
      width: 100%;
      border: dashed 1px ${({ theme }) => theme.text1};
      height: 150px;
    }
  }
`

export const ContentForm = styled.div`
  width: 70%;
`

export const ContnetPreview = styled.div`
  width: 30%;
  padding-left: 2rem;
  margin-top: -0.8rem;
  position: relative;

  .preview-container {
    position: fixed;
    .preview-title {
      font-weight: bold;
      font-size: 1.2rem;
      margin-bottom: 1rem;
    }

    .preview-content {
      border: solid 1px ${({ theme }) => theme.text1};
      width: 240px;
      height: 366px;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;

      img {
        width: 100%;
      }
    }
  }
`

export const PropertiesContainer = styled.div`
  width: 100%;

  .props-list {
    .prop-item {
      display: flex;
      flex-direction: row;

      div {
        margin-right: 1rem;
        margin-bottom: 0.5rem;

        &:last-child {
          margin-right: 0;
          margin-bottom: 0;
        }
      }
    }

    .properties-error {
      font-size: 0.9rem;
      color: ${({ theme }) => theme.red2};
      margin-bottom: 1rem;
    }
  }
`

export const ContentLabel = styled.label`
  width: 100%;
  text-align: left;
  margin-bottom: 0.5rem;
  font-weight: bold;

  span {
    font-size: 0.8rem;
    opacity: 0.8;
  }
`

export const NFTCreateButton = styled.button`
  width: 100%;
  text-align: center;
  background: ${({ theme }) => theme.bg6};
  color: #fff;
  padding: 0.5rem;
  margin-top: 0.5rem;
  font-weight: bold;
  cursor: pointer;
  user-select: none;
  outline: none;
  border: none;

  :hover {
    background: ${({ theme }) => theme.bg7};
  }

  &.disabled {
    background: ${({ theme }) => theme.bg1};
    cursor: not-allowed;
    :hover {
      background: ${({ theme }) => theme.bg1};
    }
  }
`

export const CreateFeeDiv = styled.div`
  width: 100%;
  font-size: 0.9rem;
  margin: 0.5rem 0
`
